export default __webpack_public_path__ + "static/LOtC-QB-logo-high-res-b91d559d0bf70a204b90ff6bd05080e7.png";